import React from "react";
import moment from "moment";

import Table from "../../components/table/tableHistory";

import {useGetRefHistory} from "../../graphql/graphql/ref/hooks";
import LoadingWall from "../../components/loadingWall";

const friendHeader = ["Email", "Date"];

const RefTableHistory = () => {
  const {data: history, loading: historyLoading} = useGetRefHistory();

  const referralData = history.map((referral) => ({
    Date: moment(referral?.createdAt).format("lll"),
    Email: referral?.email,
  }));

  if (historyLoading) {
    return <LoadingWall />;
  }
  return (
    <Table
      title="Referral Friends History"
      desc="Get an idea of who signed up using your link and when. This can help you identify what works and what doesn't when referring your friends or followers. We hide their email to maintain their privacy— we would do the same for you!"
      tableHeader={friendHeader}
      rows={referralData || []}
      titleNoRecord="You have no active referrals"
      descNoRecord=""
    />
  );
};

export default RefTableHistory;
